import { render, staticRenderFns } from "./LadingBill.vue?vue&type=template&id=1aaeb2ee&scoped=true&"
import script from "./LadingBill.vue?vue&type=script&lang=js&"
export * from "./LadingBill.vue?vue&type=script&lang=js&"
import style0 from "./LadingBill.vue?vue&type=style&index=0&id=1aaeb2ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaeb2ee",
  null
  
)

export default component.exports